
const sitApigee = {

};

const sitApigee_1 = {
 // coverageDetails : "/soe/digital/prospect/orderprocessservice/compassmap/5g/coverageDetails",
};

const stageApigee = {

};

const prodApigee = {

};

const compassMapApi = {
  coverageDetails : "/soe/digital/prospect/orderprocessservice/compassmap/5g/coverageDetails",
};

const envMapping = {
  LOCAL: [sitApigee_1],
  SIT: [sitApigee],
  STAGE: [stageApigee],
  WIRELESS_SIT_1: [sitApigee_1],
  WIRELESS_SIT_2: [sitApigee_1],
  WIRELESS_SIT_3: [sitApigee_1],
  WIRELESS_SIT_4: [sitApigee_1],
  WIRELESS_SIT_7: [sitApigee_1],
  WIRELESS_SIT_5: [sitApigee_1],
  WIRELESS_SIT_50: [sitApigee_1],
  WIRELESS_SIT_6: [sitApigee_1],
  WIRELESS_SIT_10: [sitApigee_1],
  PROD: [prodApigee]
};

const ATOM_CONST = {
  "www.verizon.com": "PROD",
  "espanol.verizon.com": "PROD",
  "www98.verizon.com": "STAGE",
  "wwwawssit.ebiz.verizon.com" : "SIT",
  'localhost:3005': 'LOCAL',
  'vzwqa2.verizonwireless.com': 'WIRELESS_SIT_2',
  'vzwqa8.verizonwireless.com': 'WIRELESS_SIT_2',
  'vzwqa1.verizonwireless.com': 'WIRELESS_SIT_1',
  'vzwqa3.verizonwireless.com': 'WIRELESS_SIT_3',
  'vzwqa4.verizonwireless.com': 'WIRELESS_SIT_4',
  'vzwqa7.verizonwireless.com': 'WIRELESS_SIT_7',
  'vzwqa5.verizonwireless.com': 'WIRELESS_SIT_5',
  'vzwqa50.verizonwireless.com': 'WIRELESS_SIT_50',
  'vzwqa6.verizonwireless.com': 'WIRELESS_SIT_6',
  'vzwqa10.verizonwireless.com': 'WIRELESS_SIT_10',
};

const env = () => ATOM_CONST[window.location.host];

export const getHereKey = () => {
  let key ='';
  const envi = env();
  switch (envi) {
    case 'PROD':
      key = 'EX_HK9rXSGal4YG42PfvOYdAcCkqz_rnPFM1T9QyDXg';
      break;
    default:
      key = 'ly9pWHjq6vF0cYs22NykDei60ZezcPnmEMPrcnLLOVs';
  }
  return key;
}

const getEnvUrlObj = () => {
  const currentEnv = env();
  // const urlEnv = envMapping[currentEnv];
  // return urlEnv[0];
  // Add vfw urls for current environment
  const envVfwUrl = getVfwUrl(currentEnv);

  return { ...envVfwUrl };
};

const getVfwUrl = (env, flowConfig) => {
  const vfwEnvApi = {};
  let envDomain = '';

  if (env) {
    switch (env) {
      case 'PROD':
        envDomain = 'www.verizon.com';
        break;
      case 'STAGE':
        envDomain = 'www98.verizon.com';// testing purpose
        break;
      case 'SIT':
        envDomain = 'www98.verizon.com';// testing purpose
        break;
      case 'LOCAL':
      envDomain = 'vzwqa7.verizonwireless.com'; // POINTING TO QA7 as of now
        break;
      case 'WIRELESS_SIT_2':
        envDomain = 'vzwqa2.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_1':
        envDomain = 'vzwqa1.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_3':
        envDomain = 'vzwqa3.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_4':
        envDomain = 'vzwqa4.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_7':
        envDomain = 'vzwqa7.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_5':
        envDomain = 'vzwqa5.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_50':
        envDomain = 'vzwqa50.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_6':
        envDomain = 'vzwqa6.verizonwireless.com';
        break;
      case 'WIRELESS_SIT_10':
        envDomain = 'vzwqa10.verizonwireless.com';
        break;
      default:
        envDomain = 'www.verizon.com';
    }
  }
    Object.keys(compassMapApi).forEach((key) => vfwEnvApi[key] = `https://${envDomain}${compassMapApi[key]}`);
  return vfwEnvApi;
};

let apiURLConfig = null;
export const apiUrl = () => {
  (apiURLConfig || (apiURLConfig = getEnvUrlObj()));
  return apiURLConfig;
};
